import { Injectable } from '@angular/core';
import { DashboardWidgetConfig } from './dashboard-widget-config.model';

@Injectable({
    providedIn: 'root'
})
export class DashboardConfigService {
    private getStorageKey(idIntervenant: number): string {
        return `home-innov-dashboard-config-v3-${idIntervenant}`;
    }

    getDefaultConfig(): DashboardWidgetConfig[] {
        return [
            {
                id: 'operateurs',
                title: 'Opérateurs',
                visible: true,
                order: 1,
                size: 'large',
                height: 'medium'
            },
            {
                id: 'commissions',
                title: 'Commissions',
                visible: true,
                order: 2,
                size: 'small',
                height: 'medium'
            },
            {
                id: 'teledeclarations',
                title: 'Télédéclarations',
                visible: true,
                order: 3,
                size: 'small',
                height: 'small'
            },
            {
                id: 'controles',
                title: 'Contrôles',
                visible: true,
                order: 4,
                size: 'small',
                height: 'small'
            },
            {
                id: 'historique',
                title: 'Historique des modifications majeures',
                visible: true,
                order: 5,
                size: 'small',
                height: 'small'
            },
            {
                id: 'depot-dr',
                title: 'Dépôt de DR',
                visible: true,
                order: 6,
                size: 'small',
                height: 'small'
            },
            {
                id: 'drev-aoc',
                title: 'DREV AOC',
                visible: true,
                order: 7,
                size: 'large',
                height: 'small'
            }
        ];
    }

    load(idIntervenant: number): DashboardWidgetConfig[] {
        const raw = localStorage.getItem(this.getStorageKey(idIntervenant));

        if (!raw) {
            return this.getDefaultConfig();
        }

        try {
            const saved = JSON.parse(raw) as DashboardWidgetConfig[];
            return this.mergeWithDefaults(saved);
        } catch {
            return this.getDefaultConfig();
        }
    }

    save(config: DashboardWidgetConfig[], idIntervenant: number): void {
        localStorage.setItem(this.getStorageKey(idIntervenant), JSON.stringify(config));
    }

    reset(idIntervenant: number): DashboardWidgetConfig[] {
        const config = this.getDefaultConfig();
        this.save(config, idIntervenant);
        return config;
    }

    private mergeWithDefaults(saved: DashboardWidgetConfig[]): DashboardWidgetConfig[] {
        const defaults = this.getDefaultConfig();

        return defaults.map(defaultWidget => {
            const savedWidget = saved.find(w => w.id === defaultWidget.id);
            return savedWidget ? { ...defaultWidget, ...savedWidget } : defaultWidget;
        });
    }
}